import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber, round } from "./aggregationFnUtils";

export const stdev: AggregationFn<unknown> = (columnId, leafRows) => {
	let count = 0;
	let sum = 0;
	let sumOfSquares = 0;

	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (!isComparableNumber(value)) {
			return;
		}

		count++;
		sum += value;
		sumOfSquares += value * value;
	});

	if (count > 1) {
		const mean = sum / count;
		const variance = (sumOfSquares - sum * mean) / (count - 1);
		return round(Math.sqrt(variance));
	}

	return null;
};
